export const ModalActionTypes = {
    ACTIVE_MODAL: '@@modal/ACTIVE_MODAL',
    RESET_MODAL: '@@modal/RESET_MODAL',
};
